export { StringPatterns } from './constants/RegexPatterns';
export * from './functions';
